import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const LogoutIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M14.38 5.72H7.06V18.2H14.38V19.84H5.42V4.08H14.38V5.72ZM9.16 12.8V11.12H16.84L14.46 8.76L15.54 7.68L19.82 11.96L15.54 16.24L14.46 15.16L16.84 12.8H9.16Z" />
    </SvgIcon>
  );
});
